var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "columns" }, [
      _c("label", { staticClass: "column is-3" }, [_vm._v("Task Detail : ")]),
      _c("div", { staticClass: "column is-9 breakword" }, [
        _vm._v(_vm._s(_vm.task.prodDetail))
      ])
    ]),
    _c("div", { staticClass: "columns" }, [
      _c("label", { staticClass: "column is-3" }, [_vm._v("Partner : ")]),
      _c("div", { staticClass: "column is-9" }, [
        _vm._v(_vm._s(_vm.task.vendorName))
      ])
    ]),
    _c("div", { staticClass: "columns" }, [
      _c("label", { staticClass: "column is-3" }, [
        _vm._v("Req. Lead Time : ")
      ]),
      _c("div", { staticClass: "column is-9" }, [
        _vm._v(_vm._s(_vm.task.reqLeadTime))
      ])
    ]),
    _c("div", { staticClass: "columns" }, [
      _c("label", { staticClass: "column is-3" }, [_vm._v("Lead Time : ")]),
      _c("div", { staticClass: "column is-9" }, [
        _vm._v(_vm._s(_vm.task.leadTime))
      ])
    ]),
    _c("div", { staticClass: "columns" }, [
      _c("label", { staticClass: "column is-3" }, [
        _vm._v("Est. Start Date : ")
      ]),
      _c("div", { staticClass: "column is-9" }, [
        _vm._v(_vm._s(_vm._f("Date")(_vm.task.estStartDate)))
      ])
    ]),
    _c("div", { staticClass: "columns" }, [
      _c("label", { staticClass: "column is-3" }, [
        _vm._v("Est. Finish Date : ")
      ]),
      _c("div", { staticClass: "column is-9" }, [
        _vm._v(_vm._s(_vm._f("Date")(_vm.task.estFinishDate)))
      ])
    ]),
    _c("div", { staticClass: "columns" }, [
      _c("label", { staticClass: "column is-3" }, [
        _vm._v("Original Est. Date : ")
      ]),
      _c("div", { staticClass: "column is-9" }, [
        _vm._v(_vm._s(_vm._f("Date")(_vm.task.deliveryDateOrg)))
      ])
    ]),
    _c("div", { staticClass: "columns" }, [
      _c("label", { staticClass: "column is-3" }, [
        _vm._v("Current Est. Date : ")
      ]),
      _c("div", { staticClass: "column is-9" }, [
        _vm._v(_vm._s(_vm._f("Date")(_vm.task.deliveryDateCurr)))
      ])
    ]),
    _c("div", { staticClass: "columns" }, [
      _c("label", { staticClass: "column is-3" }, [_vm._v("Delivery Date : ")]),
      _c("div", { staticClass: "column is-9" }, [
        _vm._v(_vm._s(_vm._f("Date")(_vm.task.deliveryDate)))
      ])
    ]),
    _c("div", { staticClass: "columns" }, [
      _c("label", { staticClass: "column is-3" }, [_vm._v("Remark : ")]),
      _c("div", { staticClass: "column is-9" }, [
        _vm._v(_vm._s(_vm.task.quRemark))
      ])
    ]),
    _vm.task.prodTaskStatus === "Reject"
      ? _c("div", { staticClass: "columns" }, [
          _c("label", { staticClass: "column is-3" }, [
            _vm._v("Reject Remark : ")
          ]),
          _c("div", { staticClass: "column is-9" }, [
            _vm._v(_vm._s(_vm.task.remark))
          ])
        ])
      : _vm._e(),
    _c("div", { staticClass: "columns" }, [
      _c("label", { staticClass: "column is-3" }, [_vm._v("Quotation : ")]),
      _c("div", { staticClass: "column is-9" }, [
        _vm.task.quName != ""
          ? _c("span", [
              _vm._v(
                "\n                                   " +
                  _vm._s(_vm.task.quName) +
                  "\n                                   "
              ),
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    href:
                      "https://api.musubi-thai.com/public/" +
                      _vm.task.quPath +
                      "" +
                      _vm.task.quSaveName
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-download" }),
                  _vm._v(" Download")
                ]
              )
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed3919a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed3919a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/task-detail.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-ed3919a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/task-detail.vue
// module chunks = 2 3